<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Desmarcar Encontro' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>
  <form
    class="sample-form validations-form"
    [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)"
  >
    <ion-grid class="ion-margin-top">
      <ion-row class="ion-margin-top">
        <ion-col class="ion-padding-start ion-padding-end">
          <ion-label position="stacked">{{'Motivo do Desmarque ' | translate}} <span class="danger">*</span></ion-label>
          <div style="border-bottom: 1px solid #f1f1f1;">
            <ion-textarea rows="5" cols="60" formControlName="comentarioDesmarcado" type="text"></ion-textarea>
          </div>
          <div class="validation-errors">
            <ng-container *ngFor="let validation of validation_messages.comentarioDesmarcado">
              <div
                class="error-message"
                *ngIf="(
                (validation.type === 'minlength_or_pattern' && 
                (validations_form.get('comentarioDesmarcado')?.hasError('minlength') 
                || validations_form.get('comentarioDesmarcado')?.hasError('pattern')))
                || (validation.type !== 'minlength_or_pattern' && validations_form.get('comentarioDesmarcado')?.hasError(validation.type))
              )
              && (validations_form.get('comentarioDesmarcado')?.dirty || validations_form.get('comentarioDesmarcado')?.touched)"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div>
      <ion-row>
        <ion-col size="8" offset="2">
          <ion-button
            class="btn-default"
            expand="block"
            type="submit"
            [disabled]="!validations_form.valid"
          >
            {{'Desmarcar' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </div>
  </form>
</ion-content>
